// extracted by mini-css-extract-plugin
export default {"percent":"CircularProgress_percent__p4H8b","initialFill":"CircularProgress_initialFill__bLGLx"};